import { Component, NgZone } from "@angular/core";
import {
	NavController,
	NavParams,
	AlertController,
	ModalController
} from "ionic-angular";

import { OrderdetailsModalPage } from "../../../modals/orderdetails/orderdetails.modal";

import { APIServiceProvider } from "./../../../common/services/api.service";
import { HelperServiceProvider } from "./../../../common/services/helper.service";
import { NotifyService } from "../../../services/notify.service";

@Component({
	selector: "page-inventorypendingstock",
	templateUrl: "inventorypendingstock.html"
})
export class InventoryPendingStockPage {
	constructor(
		public navCtrl: NavController,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		public zone: NgZone,
		public alertController: AlertController,
		public apiHelper: APIServiceProvider,
		public modalController: ModalController,
		public notifyService: NotifyService
	) {}

	public user_depo_id: any = localStorage.getItem("user_depo_id");

	public postParams: any = {
		transaction_type: "stock_transfer",
		manager_id: localStorage.getItem("manager_user_id")
	};

	public inventories: any = [];
	public pagination = null;
	public searchText = null;

	public inventorypending = "inventory/get-pending-transactions";
	public inventoryConformUrl = "inventory/transaction/confirm";

	ionViewDidLoad() {
		this.getInventories(this.inventorypending);
	}

	showOrderDetailsModal(order_id) {
		this.getOrderDetails(order_id).then(data => {
			let modalObject = this.modalController.create(
				OrderdetailsModalPage,
				{
					orderDetails: data
				}
			);

			modalObject.present();
		});
	}

	getOrderDetails(order_id) {
		return new Promise((resolve, reject) => {
			const params = {
				order_id,
				manager_id: localStorage.getItem("manager_user_id")
			};
			this.apiHelper
				.post("orders/get-order-details", params)
				.subscribe(result => {
					resolve(result);
				});
		});
	}

	getInventories(url, refresh?) {
		this.apiHelper.post(url, this.postParams).subscribe(
			response => {
				this.inventories = response["data"]["data"];
				this.pagination = response["data"];
				if (refresh) {
					refresh.complete();
				}
			},
			error => {}
		);
	}

	processConfirmAction(inventory_transaction_id) {
		this.apiHelper
			.post(this.inventoryConformUrl, {
				inventory_transaction_id: inventory_transaction_id,
				manager_id: localStorage.getItem("manager_user_id")
			})
			.subscribe(
				response => {
					this.notifyService.UpdateDashboard(true);
					this.getInventories(this.inventorypending);
					this.helperService.presentToast(response["msg"]);
				},
				error => {
					if (error["error"]["msg"]) {
						this.helperService.presentToast(error["error"]["msg"]);
					}
				}
			);
	}

	confirmInventoryTransaction(inventory) {
		let alertObject: any = {
			header: "Confirmation!",
			message:
				"Confirm receipt of " +
				inventory.product_erp_name +
				" " +
				inventory.product_sku +
				" " +
				inventory.product_unit +
				" From " +
				inventory.from_depo,
			buttons: [
				{
					text: "Cancel",
					role: "cancel",
					cssClass: "secondary",
					handler: blah => {
						console.log("Confirm Cancel: blah");
					}
				},
				{
					text: "OK",
					handler: () => {
						this.processConfirmAction(
							inventory.inventory_transaction_id
						);
					}
				}
			]
		};

		const alert = this.alertController.create(alertObject);

		alert.present();
	}

	doRefresh(refresher) {
		this.getInventories(this.inventorypending, refresher);
	}

	doInfiniteScroll(event) {
		if (
			!this.pagination.next_page_url ||
			this.pagination.next_page_url === "" ||
			this.pagination.next_page_url === null ||
			this.pagination.next_page_url === "null"
		) {
			event.complete();
			return;
		} else {
			this.apiHelper
				.post(null, this.postParams, this.pagination["next_page_url"])
				.subscribe(
					response => {
						this.inventories = this.inventories.concat(
							response["data"]["data"]
						);
						this.pagination = response["data"];
						event.complete();
					},
					error => {}
				);
			return;
		}
	}

	search(text) {
		this.postParams["search"] = this.searchText;
		this.getInventories(this.inventorypending);
	}

	clearSearch(text) {
		delete this.postParams["search"];
		this.getInventories(this.inventorypending);
	}
}



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorypendingstock/inventorypendingstock.ts